<template>
  <AquassistPage>
    <template v-slot:content>
      <form>
        <template v-if="!completed">
          <v-row
            align="center"
            justify="center"
          >
            <span class="title white--text my-6">
              {{ $t("forms.accountCreation") }}
            </span>
          </v-row>
          <SignupForm
            @sendData="data = $event"
            @validChanged="isFormValid = $event"
          />
          <v-row
            align="center"
            justify="center"
            class="mt-6"
          >
            <v-btn
              width="247"
              :disabled="!isFormValid"
              type="submit"
              color="secondary"
              @click.prevent="signup"
            >
              {{ $t('forms.btn.submit') }}
            </v-btn>
          </v-row>
        </template>

        <template v-else>
          <JoinTeam />
        </template>
      </form>
    </template>
  </AquassistPage>
</template>

<script>
import SignupForm from '@/components/signup/SignupForm.vue';
import AquassistPage from '@/components/login/AquassistPage.vue';
import JoinTeam from '@/components/team/JoinTeam.vue';

export default {
    components: {
        AquassistPage,
        SignupForm,
        JoinTeam,
    },
    data() {
        return {
            isFormValid: false,
            completed: false,
            invited: this.$store.getters.invitedTeam != null,
            data: null,
        };
    },
    methods: {
        async signup() {
            await this.$rq.postUserSignup(this.data);
            this.$toasted.global.toast_success({
                message: this.$t('msg.signupCompleted'),
            });
            this.completed = true;
            if (!this.invited) {
                await this.$router.push({ name: 'dashboard' });
            }
        },
    },
};
</script>
